var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  border-radius: ", ";\n  margin: ", " auto 0;\n  && {\n    ._nc .stage1 {\n      height: ", ";\n      line-height: ", ";\n    }\n    ._nc .stage1 .slider {\n      height: ", ";\n      line-height: ", ";\n      border-radius: ", ";\n      box-shadow: 0 0 3px rgba(254, 83, 26, 0.6);\n      background-color: #fff;\n      border: 1px solid rgba(254, 83, 26, 0.6);\n    }\n\n    ._nc .stage1 .slider .label {\n      height: ", ";\n      line-height: ", ";\n    }\n\n    ._nc .stage1 .button {\n      width: ", ";\n      height: ", ";\n      line-height: ", ";\n      border-radius: ", ";\n      background-color: rgba(254, 83, 26, 0.6);\n    }\n    ._nc .stage1 .button .icon {\n      margin-left: ", ";\n    }\n    ._nc .stage1 .track div {\n      height: ", ";\n      border-radius: ", ";\n      letter-spacing: ", ";\n      font-size: ", ";\n      color: #fff;\n    }\n    ._nc .stage1 .icon.yes {\n      position: absolute;\n      left: ", ";\n      width: ", ";\n      height: ", ";\n      border-radius: ", ";\n      background-color: #fff;\n      &::before {\n        content: '';\n        width: 8px;\n        height: 25px;\n        border-style: solid;\n        border-width: 0 4px 4px 0;\n        transform: rotate(45deg);\n        border-color: rgba(254, 83, 26, 0.6);\n        position: absolute;\n        left: ", ";\n      }\n    }\n    ._nc .stage1 .bg-green {\n      height: ", ";\n      line-height: ", ";\n      background-color: rgb(251, 138, 104);\n    }\n  }\n"], ["\n  width: ", ";\n  border-radius: ", ";\n  margin: ", " auto 0;\n  && {\n    ._nc .stage1 {\n      height: ", ";\n      line-height: ", ";\n    }\n    ._nc .stage1 .slider {\n      height: ", ";\n      line-height: ", ";\n      border-radius: ", ";\n      box-shadow: 0 0 3px rgba(254, 83, 26, 0.6);\n      background-color: #fff;\n      border: 1px solid rgba(254, 83, 26, 0.6);\n    }\n\n    ._nc .stage1 .slider .label {\n      height: ", ";\n      line-height: ", ";\n    }\n\n    ._nc .stage1 .button {\n      width: ", ";\n      height: ", ";\n      line-height: ", ";\n      border-radius: ", ";\n      background-color: rgba(254, 83, 26, 0.6);\n    }\n    ._nc .stage1 .button .icon {\n      margin-left: ", ";\n    }\n    ._nc .stage1 .track div {\n      height: ", ";\n      border-radius: ", ";\n      letter-spacing: ", ";\n      font-size: ", ";\n      color: #fff;\n    }\n    ._nc .stage1 .icon.yes {\n      position: absolute;\n      left: ", ";\n      width: ", ";\n      height: ", ";\n      border-radius: ", ";\n      background-color: #fff;\n      &::before {\n        content: '';\n        width: 8px;\n        height: 25px;\n        border-style: solid;\n        border-width: 0 4px 4px 0;\n        transform: rotate(45deg);\n        border-color: rgba(254, 83, 26, 0.6);\n        position: absolute;\n        left: ", ";\n      }\n    }\n    ._nc .stage1 .bg-green {\n      height: ", ";\n      line-height: ", ";\n      background-color: rgb(251, 138, 104);\n    }\n  }\n"])), px2rem(650), px2rem(44), px2rem(40), px2rem(79), px2rem(88), px2rem(79), px2rem(79), px2rem(88), px2rem(79), px2rem(79), px2rem(120), px2rem(79), px2rem(79), px2rem(44), px2rem(15), px2rem(79), px2rem(44), px2rem(6), px2rem(32), px2rem(-10), px2rem(120), px2rem(79), px2rem(44), px2rem(50), px2rem(79), px2rem(79));
var AliCaptcha = /** @class */ (function (_super) {
    __extends(AliCaptcha, _super);
    function AliCaptcha(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            evokeValidation: function (bizCode) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // @ts-ignore
                    if (!window.getNC) {
                        return [2 /*return*/, false];
                    }
                    if (bizCode === '400') {
                        // @ts-ignore
                        getNC().then(function () {
                            // @ts-ignore
                            NoCaptcha.upLang('cn', {
                                LOADING: '加载中...',
                                SLIDER_LABEL: '请向右滑动验证',
                                CHECK_Y: '验证通过',
                                ERROR_TITLE: '非常抱歉，这出错了...',
                            });
                            // @ts-ignore
                            _nvc_nc.reset();
                        });
                    }
                    return [2 /*return*/, true];
                });
            }); },
            verifyComponent: React.createElement(Container, { id: "_ali-captcha", className: "nc-container" }),
            getAliCaptcha: function () { return __awaiter(_this, void 0, void 0, function () {
                var aliCaptcha;
                return __generator(this, function (_a) {
                    aliCaptcha = window.getNVCVal();
                    return [2 /*return*/, aliCaptcha];
                });
            }); },
        };
        return _this;
    }
    AliCaptcha.prototype.componentDidMount = function () {
        this.init();
    };
    AliCaptcha.prototype.reset = function () {
        // @ts-ignore
        window.nvcReset();
    };
    AliCaptcha.prototype.init = function () {
        var aliCaptchaScript = document.getElementById('ali-captcha-script');
        if (aliCaptchaScript) {
            return;
        }
        // @ts-ignore
        window.NVC_Opt = {
            // 无痕配置 && 滑动验证、刮刮卡、问答验证码通用配置
            appkey: 'FFFF0N00000000007F8A',
            scene: 'nvc_activity_h5',
            isH5: true,
            popUp: false,
            renderTo: '#_ali-captcha',
            // TODO type def
            nvcCallback: function (data) {
                // data为getNVCVal()的值，此函数为二次验证滑动或者刮刮卡通过后的回调函数
                // data跟业务请求一起上传，由后端请求AnalyzeNvc接口，接口会返回100或者900
            },
            trans: { key1: 'code0', nvcCode: 400 },
            language: 'cn',
            // 滑动验证长度配置
            customWidth: 300,
            // 刮刮卡配置项
            width: 300,
            height: 100,
            elements: [
                '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
                '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
            ],
            bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
            bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
            obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
            bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
            obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
            bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
            upLang: {
                cn: {
                    _ggk_guide: '请在屏幕上滑动，刮出两面盾牌',
                    _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
                    _ggk_loading: '加载中',
                    _ggk_fail: [
                        '呀，盾牌不见了<br/>请',
                        'javascript:NoCaptcha.reset()',
                        '再来一次',
                        '或',
                        'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
                        '反馈问题',
                    ],
                    _ggk_action_timeout: [
                        '我等得太久啦<br/>请',
                        'javascript:NoCaptcha.reset()',
                        '再来一次',
                        '或',
                        'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
                        '反馈问题',
                    ],
                    _ggk_net_err: [
                        '网络实在不给力<br/>请',
                        'javascript:NoCaptcha.reset()',
                        '再来一次',
                        '或',
                        'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
                        '反馈问题',
                    ],
                    _ggk_too_fast: [
                        '您刮得太快啦<br/>请',
                        'javascript:NoCaptcha.reset()',
                        '再来一次',
                        '或',
                        'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
                        '反馈问题',
                    ],
                },
            },
        };
        var newAliCaptchaScript = document.createElement("script");
        newAliCaptchaScript.id = 'ali-captcha-script';
        newAliCaptchaScript.src = '//g.alicdn.com/sd/nvc/1.1.112/guide.js';
        document.body.appendChild(newAliCaptchaScript);
    };
    AliCaptcha.prototype.render = function () {
        // @ts-ignore
        var children = this.props.children(__assign(__assign({}, this.props), this.state));
        return children || null;
    };
    return AliCaptcha;
}(Component));
export { AliCaptcha };
var templateObject_1;
//# sourceMappingURL=AliCaptcha.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AliCaptcha.js
// module id = 1059
// module chunks = 0